import { BareActionContext } from 'vuex-typex'
import { StatementState } from '../state'
import { RootState } from '../..'
import statementStore from '../statement-store'
import setStatementQuery from './set-statement-query'

export default async function toggleNotReactedByMe(context: BareActionContext<StatementState, RootState>)
{
    const form = statementStore.state.statementSearchForm
    form.jybedByMe = false
    form.consideredByMe = false
    form.ignoredByMe = false

    setStatementQuery(context)

    return
}
